/** Chrome may autofill login email into generic text inputs — detect and reject. */
export function looksLikeEmailAutofill(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length > 0 && trimmed.includes("@");
}

export function sanitizeTickerFilterValue(value: string): string {
  const trimmed = value.trim();
  if (!trimmed || looksLikeEmailAutofill(trimmed)) return "";
  return trimmed;
}

/** HTML attributes for ticker filter inputs (leading space for template insertion). */
export const TICKER_FILTER_INPUT_ATTRS =
  ' name="sfe-ticker-filter" autocomplete="off" autocorrect="off" autocapitalize="characters" spellcheck="false" inputmode="text" data-lpignore="true" data-1p-ignore data-form-type="other"';

function isTickerFilterInputCandidate(input: HTMLInputElement): boolean {
  if (input.type !== "text" && input.type !== "search") return false;
  const id = input.id.toLowerCase();
  if (id.includes("ticker") || id === "sfe-watchlist-input") return true;
  if (input.name.startsWith("sfe-ticker-filter")) return true;
  const aria = input.getAttribute("aria-label")?.toLowerCase() ?? "";
  if (aria.includes("ticker")) return true;
  const placeholder = input.placeholder.toLowerCase();
  if (placeholder.includes("ticker") || placeholder.includes("symbol")) return true;
  return false;
}

/** Block browser/password-manager autofill on a ticker filter field. */
export function guardTickerFilterInput(input: HTMLInputElement): void {
  input.setAttribute("autocomplete", "off");
  if (!input.name || input.name === "email" || input.name.includes("auth")) {
    input.name = input.id ? `sfe-ticker-filter-${input.id}` : "sfe-ticker-filter";
  }
  input.setAttribute("autocorrect", "off");
  input.setAttribute("autocapitalize", "characters");
  input.setAttribute("spellcheck", "false");
  input.setAttribute("inputmode", "text");
  input.setAttribute("data-lpignore", "true");
  input.setAttribute("data-1p-ignore", "");
  input.setAttribute("data-form-type", "other");

  if (looksLikeEmailAutofill(input.value)) {
    input.value = "";
  }

  if (input.dataset.sfeTickerGuard === "1") return;
  input.dataset.sfeTickerGuard = "1";
  input.setAttribute("readonly", "readonly");
  input.addEventListener(
    "focus",
    () => {
      input.removeAttribute("readonly");
    },
    { once: true },
  );
}

export function guardTickerFilterInputs(root: ParentNode = document): void {
  for (const el of root.querySelectorAll("input")) {
    if (el instanceof HTMLInputElement && isTickerFilterInputCandidate(el)) {
      guardTickerFilterInput(el);
    }
  }
}
